import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import "./allpages.css";

const PatientIdModal = ({ openPatientId, handleClose, lead }) => {
  const handleCopy = () => {
    if (lead?.patientId) {
      navigator.clipboard.writeText(lead.patientId);
      toast.success("Patient ID copied to clipboard!");
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openPatientId}
    >
      <DialogContent dividers>
        <div className="d-flex align-items-center justify-content-between">
          {lead?.patientId && (
            <div className="patientId">
              <p>NVM Patient Id </p>
              <Tooltip
                title="This is the Unique Patient Id"
                placement="top"
                arrow
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.75 5.875C10.75 8.56741 8.56741 10.75 5.875 10.75C3.18261 10.75 1 8.56741 1 5.875C1 3.18261 3.18261 1 5.875 1C8.56741 1 10.75 3.18261 10.75 5.875Z"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                  />
                  <path
                    d="M5.3335 5.87498V8.04165C5.3335 8.34081 5.576 8.58331 5.87516 8.58331C6.17433 8.58331 6.41683 8.34081 6.41683 8.04165V5.87498C6.41683 5.57582 6.17433 5.33331 5.87516 5.33331C5.576 5.33331 5.3335 5.57582 5.3335 5.87498Z"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6.41683 3.70835C6.41683 3.4092 6.17433 3.16669 5.87516 3.16669C5.576 3.16669 5.3335 3.4092 5.3335 3.70835C5.3335 4.00751 5.576 4.25002 5.87516 4.25002C6.17433 4.25002 6.41683 4.00751 6.41683 3.70835Z"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                  />
                </svg>
              </Tooltip>
              {lead?.patientId}
              <IconButton>
                <svg
                  onClick={handleCopy}
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 8.99995V9.5C7.5 10.0523 7.0523 10.5 6.5 10.5H2.5C1.94771 10.5 1.5 10.0523 1.5 9.5V5.49995C1.5 4.94769 1.94769 4.49998 2.49996 4.49996L3 4.49994M5.5 1.49994H9.5C10.0523 1.49994 10.5 1.94765 10.5 2.49994V6.49995C10.5 7.0522 10.0523 7.49995 9.5 7.49995H5.5C4.94771 7.49995 4.5 7.0522 4.5 6.49995V2.49994C4.5 1.94765 4.94771 1.49994 5.5 1.49994Z"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                  />
                </svg>
              </IconButton>
            </div>
          )}

          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PatientIdModal;
